import { toDate } from "./licenses";

// Basic details a distributor can keep about a customer. Limits match
// firestore.rules and functions/index.js.
export const CUSTOMER_FIELDS = [
  { name: "name", label: "Customer name", max: 200, required: true },
  { name: "email", label: "Email", max: 200, type: "email" },
  { name: "phone", label: "Phone", max: 50, type: "tel" },
  { name: "location", label: "City / address", max: 200 },
  { name: "notes", label: "Notes", max: 1000, multiline: true },
];

export const emptyCustomer = () =>
  Object.fromEntries(CUSTOMER_FIELDS.map((f) => [f.name, ""]));

// The last `months` calendar months, oldest first, with their date range
// (for Firestore count queries per month).
export function monthBuckets(months = 12, now = new Date()) {
  const buckets = [];
  for (let i = months - 1; i >= 0; i--) {
    const start = new Date(now.getFullYear(), now.getMonth() - i, 1);
    buckets.push({
      key: `${start.getFullYear()}-${String(start.getMonth() + 1).padStart(2, "0")}`,
      label: start.toLocaleDateString(undefined, { month: "short" }),
      longLabel: start.toLocaleDateString(undefined, {
        month: "long",
        year: "numeric",
      }),
      start,
      end: new Date(now.getFullYear(), now.getMonth() - i + 1, 1),
    });
  }
  return buckets;
}

export const CUSTOMER_CSV_COLUMNS = (distributorName) => [
  { label: "Customer", value: (c) => c.name },
  { label: "Distributor", value: (c) => distributorName(c.distributorId) },
  { label: "Email", value: (c) => c.email },
  { label: "Phone", value: (c) => c.phone },
  { label: "City / address", value: (c) => c.location },
  { label: "Notes", value: (c) => c.notes },
  { label: "Keys", value: (c) => c.keyCount ?? 0 },
  {
    label: "Added",
    value: (c) => toDate(c.createdAt)?.toISOString().slice(0, 10) || "",
  },
];
